export class FacePressuresCalculation {

    constructor(modelSection, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.modelSection = modelSection ?? null;
        this.k0CalcMethod = data.k0CalcMethod ?? null;
        this.kaCalcMethod = data.kaCalcMethod ?? null;
        this.k1CalcMethod = data.k1CalcMethod ?? null;
        this.k2CalcMethod = data.k2CalcMethod ?? null;
        this.trCalcMethod = data.trCalcMethod ?? null;
        this.testingStartAngleZetaCrit = data.testingStartAngleZetaCrit ?? null;
        this.testingEndAngleZetaCrit = data.testingEndAngleZetaCrit ?? null;
        this.testingAngleIncrementZetaCrit = data.testingAngleIncrementZetaCrit ?? null;
        this.earthPressureSafetyCoefficientAgainstFaceCollapse = data.earthPressureSafetyCoefficientAgainstFaceCollapse ?? null;
        this.earthPressureSafetyCoefficientAgainstBlowUp = data.earthPressureSafetyCoefficientAgainstBlowUp ?? null;
        this.groundwaterPressureSafetyCoefficientAgainstFaceCollapse = data.groundwaterPressureSafetyCoefficientAgainstFaceCollapse ?? null;
        this.groundwaterPressureSafetyCoefficientAgainstBlowUp = data.groundwaterPressureSafetyCoefficientAgainstBlowUp ?? null;
        this.maximumFacePressureDeviations = data.maximumFacePressureDeviations ?? null;
        this.safetyFactorForMaxFacePressure = data.safetyFactorForMaxFacePressure ?? null;
        this.slurryUnitWeight = data.slurryUnitWeight ?? null;
        this.surchargeForMinimumRequiredPressureOnly = data.surchargeForMinimumRequiredPressureOnly ?? null;
        this.intervals = data.intervals ?? [];
        this.forcesAtAngles = data.forcesAtAngles ?? [];
        this.pressuresAtLevels = data.pressuresAtLevels ?? [];

    }

}
